import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { OpenMetadataTag } from '@/shared/api/openmetadata/types';

export type Container = {
  id: string;
  name: string;
  displayName?: string;
  fullyQualifiedName: string;
  description?: string;
  deleted?: boolean;
  owners?: Array<{
    id: string;
    name: string;
    displayName?: string;
    type: string;
  }>;
  tags?: OpenMetadataTag[];
  domains?: Array<{
    id: string;
    name: string;
    displayName?: string;
  }>;
  dataProducts?: Array<{
    id: string;
    name: string;
    displayName?: string;
  }>;
};

export type ContainersResponse = {
  data: Container[];
  paging?: {
    total: number;
    after?: string;
    before?: string;
  };
};

export type FetchContainersOptions = {
  includeDeleted?: boolean;
  limit?: number;
};

export const fetchServiceContainers = async (
  serviceName: string,
  options: FetchContainersOptions = {}
): Promise<ContainersResponse> => {
  const { includeDeleted = false, limit = 15 } = options;

  const response = await openMetadataApiClient.get<ContainersResponse>('/containers', {
    params: {
      service: serviceName,
      fields: 'tags,owners,domains',
      root: true,
      include: includeDeleted ? 'deleted' : 'non-deleted',
      limit,
    },
  });

  return response.data;
};
